<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px">
      <el-form-item label="类型">
        <el-radio-group v-model="radio" @change="rachange">
          <el-radio :label="1">投放组</el-radio>
          <el-radio :label="2">运营组</el-radio>
          <el-radio :label="3">投放版位</el-radio>
          <el-radio :label="4">书籍归属</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radio === 4 || radio === 1 || radio === 3" label="运营组">
        <el-select v-model="value1" multiple placeholder="请选择运营组">
          <el-option v-if="options.length>0" :label="selectAllLabel" :value="selectAllValue" @click.native="selectAll(value1,options,1)" />
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.operation_group_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="radio === 2 || radio === 1 " label="书籍类型">
        <el-select v-model="book_type" multiple placeholder="请选择类型">
          <el-option v-if="optionbook.length>0" :label="selectAllLabelBook" :value="selectAllValueBook" @click.native="selectAll(book_type,optionbook,2)" />
          <el-option
            v-for="(item,index) in optionbook"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="投放位置">
        <!-- <el-autocomplete
          v-model="app_id"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择投放位置"
          multiple
          @clear="(app_id = null)"
          @select="handleSelect"
        /> -->
        <el-select v-model="toufangvalue" filterable multiple placeholder="请选择投放位置">
          <el-option v-if="optionsr.length>0" :label="selectAllLabelPlace" :value="selectAllValuePlace" @click.native="selectAll(toufangvalue,optionsr,3)" />
          <el-option
            v-for="item in optionsr"
            :key="item.id"
            :label="item.position_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sunmbit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getOperationGroupList, exportDifferentDimensionV2, dropLocationList, updateReleaseBookType } from '@/api/copyReleaseGroup.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      radio: 1,
      value1: [],
      options: [],
      time: [],
      pickerOptions: {
        disabledDate(picker) {
          const curDate = (new Date()).getTime() // 获得当前时间的时间戳
          const three = 30 * 24 * 3600 * 1000 // 计算30天的时间戳
          const thirtyDay = curDate - three // 获得30天前的时间戳
          return picker.getTime() > Date.now() || picker.getTime() < thirtyDay
        }
      },
      app_id: null,
      app_ids: null,
      pageinfo: {
        page: 1,
        pageSize: 200
      },
      optionsr: [],
      optionbook: [],
      book_type: [],
      toufangvalue: []
    }
  },
  computed: {
    selectAllLabel() {
      return this.value1.length === this.options.length ? '取消全选' : '全选'
    },
    selectAllValue() {
      return this.value1.length === this.options.length ? '' : '全选'
    },
    selectAllLabelBook() {
      return this.book_type.length === this.optionbook.length ? '取消全选' : '全选'
    },
    selectAllValueBook() {
      return this.book_type.length === this.optionbook.length ? '' : '全选'
    },
    selectAllLabelPlace() {
      return this.toufangvalue.length === this.optionsr.length ? '取消全选' : '全选'
    },
    selectAllValuePlace() {
      return this.toufangvalue.length === this.optionsr.length ? '' : '全选'
    }
  },
  watch: {
    value1(newValue) {
      if (newValue.length === this.options.length && !this.options.every(option => newValue.includes(option.id))) {
        this.value1 = []
      }
    },
    book_type(newValue) {
      if (newValue.length === this.optionbook.length && !this.optionbook.every(option => newValue.includes(option))) {
        this.book_type = []
      }
    },
    toufangvalue(newValue) {
      if (newValue.length === this.optionsr.length && !this.optionsr.every(option => newValue.includes(option.id))) {
        this.toufangvalue = []
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    selectAll(value1, options, type) {
      if (value1.length < options.length) {
        switch (type) {
          case 1:
            this.value1 = []
            this.value1 = options.map((item) => item.id)
            break
          case 2:
            this.book_type = []
            this.book_type = options.map((item) => item)
            break
          case 3:
            this.toufangvalue = []
            this.toufangvalue = options.map((item) => item.id)
            break
          default:
            break
        }
      } else {
        switch (type) {
          case 1:
            this.value1 = []
            break
          case 2:
            this.book_type = []
            break
          case 3:
            this.toufangvalue = []
            break
          default:
            break
        }
      }
    },
    send() {
      this.reportlist()
      this.toufanglist()
      this.booktypeList()
    },
    rachange(val) {
      if (val === 2) {
        this.value1 = []
        this.toufangvalue = []
        // this.app_id = null
        // this.app_ids = null
      }
      if (val === 1) {
        this.toufangvalue = []
        // this.app_id = null
        // this.app_ids = null
      }
      if (val === 3) {
        this.toufangvalue = []
        this.book_type = []
        // this.app_id = null
        // this.app_ids = null
      }
      if (val === 4) {
        this.book_type = []
      }
    },
    async toufanglist() {
      const data = await dropLocationList({ ...this.pageinfo })
      console.log('data', data)
      this.optionsr = data.data.list
    },
    async booktypeList() {
      const res = await updateReleaseBookType()
      this.optionbook = res.data
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === '') {
        this.app_id = null
        this.app_ids = null
      }
      const data = await dropLocationList({ ...this.pageinfo, name: this.app_id })
      const newArr = data.data.list.map((item) => {
        return { ...item, value: item.position_name, address: item.id }
      })
      cb(newArr)
    },
    handleSelect(val) {
      this.app_ids = val.id
      console.log(val)
    },
    async reportlist() {
      const data = await getOperationGroupList({
        page: 1,
        pageSize: 100
      })
      this.options = data.data.list
      console.log('data', data)
    },
    async sunmbit() {
      // if (this.radio === 4) {
      //   if (this.value1.length === 0) {
      //     this.$message({
      //       message: '请选择运营组',
      //       type: 'error'
      //     })
      //     return
      //   }
      //   if (this.app_ids === null) {
      //     this.$message({
      //       message: '请选择正确的投放位置',
      //       type: 'error'
      //     })
      //     return
      //   }
      // }
      const data = await exportDifferentDimensionV2({
        type: this.radio,
        // position_id: this.app_ids,
        position_id: this.toufangvalue.length !== 0 ? this.toufangvalue.join(',') : '',
        book_type: this.book_type.length !== 0 ? this.book_type.join(',') : '',
        operation_ids: this.value1.length !== 0 ? this.value1.join(',') : '',
        begin_time: this.time.length !== 0 ? this.time[0] : '',
        end_time: this.time.length !== 0 ? this.time[1] : ''
      })
      this.$emit('updatanew')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
::v-deep.el-select > .el-input {
    width: 350px;
}
</style>
